<template>
  <div>
    <UButton label="Refresh" @click="refresh" />
    <UButton label="Create" @click="create" />
    <UTable :rows="prices" />
  </div>
</template>

<script setup>
const app = useAppConfig();
const toast = useToast();
const prices = ref([]);

const create = () => {
  $fetch(app.service + "/prices", {
    method: "POST",
    body: { from: "BTC", to: "EUR", rate: 37000.45 },
  }).then((data) => {
    toast.add({ title: "Price updated", timeout: 2000 });
  });
};

const refresh = () => {
  $fetch(app.service + "/prices").then((data) => {
    prices.value = data;
  });
};
</script>
